import * as React from 'react';

export const IconVideo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 0A1.5 1.5 0 00.5 1.5v15A1.5 1.5 0 002 18h12a1.5 1.5 0 001.5-1.5V11l6 4V3l-6 4V1.5A1.5 1.5 0 0014 0H2z"
      fill="#fff"
    />
  </svg>
);

IconVideo.displayName = 'IconVideo';
